// Compact locale-aware formatter for fractional hour durations (Xm, Xh/Xu).
import { getCurrentLocale } from '@/i18n/useT';

/** Compact duration: Xm or Xh/Xu or Xh/Xu Ym (hour suffix follows app locale). */
export function formatHours(hours) {
  const hourSuffix = getCurrentLocale() === 'en' ? 'h' : 'u';
  const sign = hours < 0 ? '-' : '';
  const totalMinutes = Math.round(Math.abs(hours) * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${sign}${m}m`;
  if (m === 0) return `${sign}${h}${hourSuffix}`;
  return `${sign}${h}${hourSuffix} ${m}m`;
}
